//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiEmoticonSadOutline, mdiEmoticonExcitedOutline } from '@mdi/js'

export default {
  setup() {
    const rating = ref(4.5)

    return {
      rating,

      // icons
      icons: {
        mdiEmoticonSadOutline,
        mdiEmoticonExcitedOutline,
      },
    }
  },
}
